import http from '@/communication/AuthConnection'

export default async ({ state, commit }, payload) => {
  try {
    const info = {
      quoted: {
        cmedLab: payload.cmedLab,
        cmedPrice: payload.cmedPrice,
        cmedTotalPrice: payload.cmedTotalPrice,
        cmedPerc: payload.cmedPerc,
        isPriceGuaranted: payload.isPriceGuaranted,
        isQuoted: !payload.notQuote,
        itemId: payload.item,
        lab: payload.lab,
        price: payload.price,
        priceTotal: payload.priceTotal,
        proposalPrice: payload.proposalPrice,
        proposalTotalPrice: payload.proposalTotalPrice,
        proposalPerc: payload.proposalPerc,
        minimumPrice: payload.minimumPrice,
        minimumTotalPrice: payload.minimumTotalPrice,
        minimumPerc: payload.minimumPerc,
        proposalIsHigherThanMaxprice: payload.proposalIsHigherThanMaxprice
      }
    }

    await http.post(`/v1/item-pricing/set-quote-item`, payload)
    return info
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/select-quote-item/index.js